/**
 * Tab panels for Doctapet PDP "All Details" section
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-doctapet-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-doctapet-tab]');
    const panels = root.querySelectorAll('[data-doctapet-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-doctapet-tab');
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((p) => {
          const match = p.getAttribute('data-doctapet-panel') === id;
          p.classList.toggle('is-active', match);
        });
      });
    });
  });
});
